import * as Sentry from "@sentry/vue";
import SIM_FRONT_ENV from "@/utils/defaults";



export function initSentry(app) {
    console.log("Initializing Sentry...");
    Sentry.init({
        app,
        dsn: "https://99b5bf89e05f209d539b0e093fef1774@o4510419449675776.ingest.de.sentry.io/4510432370491472",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        release: "sim-front@" + process.env.npm_package_version,
        environment: SIM_FRONT_ENV.NODE_ENV,
        sendDefaultPii: true,
        // Tracing
        tracesSampleRate: 0.1, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        // tracePropagationTargets: ["localhost", /^https:\/\/produuz\.it\/api/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}
